module.exports = __webpack_public_path__ + "img/launch_240px.245dbaff.png";